import React from "react";
import { Tabs } from "antd";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageHeader from "../shared/PageHeader";
import BwaTab from "./BwaTab";
import EuerTab from "./EuerTab";
import SusaTab from "./SusaTab";
import LiquidityTab from "./LiquidityTab";
import NachkalkulationTab from "./NachkalkulationTab";
import YearEndTab from "./YearEndTab";
import DebitorenTab from "./DebitorenTab";
import AusgangsbuchTab from "./AusgangsbuchTab";
import CorrectionsTab from "./CorrectionsTab";
import PaymentBehaviourTab from "./PaymentBehaviourTab";

// /user/accounting/reports/:tab? — BWA, EÜR, SuSa, Liquidität, Nachkalkulation, Debitoren-
// Saldenliste (+ Kontoauszug), Rechnungsausgangsbuch, Korrekturen, Zahlungsverhalten, Jahresabschluss
const Reports = () => {
  const { t } = useTranslation("accounting");
  const history = useHistory();
  const match = useRouteMatch("/user/accounting/reports/:tab?");
  const active = match?.params?.tab || "bwa";
  return (
    <div>
      <PageHeader title={t("Reports & liquidity")} />
      <Tabs
        activeKey={active}
        onChange={key => history.push(`/user/accounting/reports/${key}`)}
        destroyInactiveTabPane
        items={[
          { key: "bwa", label: t("BWA"), children: <BwaTab /> },
          { key: "euer", label: t("EÜR"), children: <EuerTab /> },
          { key: "susa", label: t("Trial balance (SuSa)"), children: <SusaTab /> },
          { key: "liquidity", label: t("Liquidity forecast"), children: <LiquidityTab /> },
          {
            key: "nachkalkulation",
            label: t("Post-calculation"),
            children: <NachkalkulationTab />
          },
          { key: "debitoren", label: t("Customer balances"), children: <DebitorenTab /> },
          {
            key: "ausgangsbuch",
            label: t("Outgoing invoice register"),
            children: <AusgangsbuchTab />
          },
          { key: "corrections", label: t("Corrections by reason"), children: <CorrectionsTab /> },
          {
            key: "payment-behaviour",
            label: t("Payment behaviour"),
            children: <PaymentBehaviourTab />
          },
          { key: "year-end", label: t("Year-end closing"), children: <YearEndTab /> }
        ]}
      />
    </div>
  );
};

export default Reports;
